import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { HeroUIProvider } from "@heroui/system"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HeroUIProvider>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster
          toastOptions={{
            className: 'bg-main-dark text-white',
          }}
        />
      </QueryClientProvider>
    </HeroUIProvider>
  </React.StrictMode>,
)
